import { render } from "./Audiences.vue?vue&type=template&id=35e71b57&scoped=true"
import script from "./Audiences.vue?vue&type=script&lang=js"
export * from "./Audiences.vue?vue&type=script&lang=js"

import "./Audiences.vue?vue&type=style&index=0&id=35e71b57&scoped=true&lang=css"

import exportComponent from "/Users/rosswilliams/aqfer-workspace/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35e71b57"]])

export default __exports__